import React, { useCallback } from 'react';
import { components } from 'react-select';
import { Checkbox } from '../../../../../atoms/Checkbox';
import { useStyles } from './SelectAllOption.styles';
import { SELECT_DROPDOWN_SELECT_ALL_VALUE } from '../../constants';
export function SelectAllOption(props) {
    const { customProps, getValue, innerProps, isSelected, options, setValue } = props;
    const { id: parentId, rootProps } = props.selectProps;
    const { isIndeterminate: isIndeterminateOverride } = customProps || {};
    const { asyncMenu } = rootProps;
    const classes = useStyles();
    const selectAllId = `${parentId}-select-all`;
    const allValues = getValue();
    const allOptions = options;
    const isCheckboxIndeterminate = allValues.length > 0 && allValues.length !== allOptions.length - 1;
    const isCheckboxSelected = allValues.length === allOptions.length - 1 || isCheckboxIndeterminate;
    const handleSelectAllClick = useCallback(() => {
        if (isCheckboxSelected) {
            setValue([], 'deselect-option');
        }
        else {
            const allOptionsWithoutSelectAll = allOptions.filter((option) => option.value !== SELECT_DROPDOWN_SELECT_ALL_VALUE);
            setValue(allOptionsWithoutSelectAll, 'select-option');
        }
    }, [allOptions, isCheckboxSelected, setValue]);
    return (React.createElement("div", { id: selectAllId, className: classes.selectAll },
        React.createElement(components.Option, Object.assign({}, props, { innerProps: Object.assign(Object.assign({}, innerProps), (asyncMenu ? undefined : { onClick: handleSelectAllClick })) }),
            React.createElement(Checkbox, { className: classes.checkbox, checked: asyncMenu ? isSelected : isCheckboxSelected, color: "primary", indeterminate: asyncMenu ? isIndeterminateOverride : isCheckboxIndeterminate }),
            "Select all")));
}
//# sourceMappingURL=SelectAllOption.js.map